import React, { Component, memo, useEffect, useState } from 'react'
import MomentUtils from '@date-io/moment'
import {
    ClickAwayListener,
    FormLabel,
    Grid,
    IconButton,
    makeStyles,
    TextField,
} from '@material-ui/core'
import { KeyboardDatePicker, DatePickerProps, MuiPickersUtilsProvider } from '@material-ui/pickers'
import moment, { Moment } from 'moment'

import './style.scss'

const useStyles = makeStyles(() => ({
    errorBorder: {
        '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: 'red !important',
        },
    },
}))

interface Props {
    value?: Moment | Date | string | undefined | null
    label?: string
    required?: boolean
    noAway?: boolean
    notDefaultValue?: boolean
    onChange?: (date: Moment | Date | string | undefined | null) => void
    icon?: Component
    fromPatientForm?: string
}

const DatePicker = memo(
    ({ value, label, required, notDefaultValue, icon, fromPatientForm, ...props }: Props & DatePickerProps) => {
        const [date, setDate] = useState<Moment | Date | string | undefined | null>(
            value || notDefaultValue ? null : new Date(),
        )

        const handleClickAway = () => {
            if(fromPatientForm != "yes"){
                if (!props.noAway) {
                    props.onChange(date as Date)
                }
            }
        }
        useEffect(() => {
            value && setDate(value)
        }, [value])
        const classes = useStyles()
        return (
            <div className="fff-datepicker">
                {label && (
                    <FormLabel
                        component="p"
                        className="input-form-label"
                        style={{ fontSize: 14, fontWeight: 500 }}>
                        <span
                            className={`${!!required ? 'required' : ''}`}
                            style={{ color: '#303E4E' }}>
                            {label}
                        </span>
                    </FormLabel>
                )}

                <ClickAwayListener onClickAway={handleClickAway}>
                    <Grid container item xs={12}>
                        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
                            <KeyboardDatePicker
                                {...props}
                                autoOk
                                variant="inline"
                                inputVariant="outlined"
                                format={props.format || 'MM/DD/YYYY'}
                                value={date}
                                error={props.error}
                                helperText={
                                    <div
                                        style={{
                                            textTransform: 'initial',
                                        }}>
                                        {props.helperText}
                                    </div>
                                }
                                placeholder="MM/DD/YYYY"
                                onChange={(_, value) => {
                                    setDate(value)
                                    props.onChange && props.onChange(value)
                                }}
                                keyboardIcon={icon}
                                TextFieldComponent={(textFieldProps) => (
                                    <div className={classes.errorBorder}>
                                        <TextField
                                            variant="outlined"
                                            {...textFieldProps}
                                            error={props.error}
                                            InputProps={{
                                                ...textFieldProps.InputProps,
                                            }}
                                        />
                                    </div>
                                )}
                            />
                        </MuiPickersUtilsProvider>
                    </Grid>
                </ClickAwayListener>
            </div>
        )
    },
)

export { DatePicker }
export default DatePicker
